import { useNavigate } from 'react-router-dom';
import {
  Avatar,
  Card,
  IconButton,
  Rating,
  Grid,
  Tooltip,
  Typography,
  Stack
} from '@mui/material';
import {
  Clock,
  Book1,
  Heart,
  LanguageSquare,
  ArrowLeft,
  Note1,
  Book,
  SidebarLeft
} from 'iconsax-react';
import NoImage from 'assets/images/homepage/NoCourseImage.jpg';
import useAuth from 'hooks/useAuth';
import { useEffect, useState } from 'react';
import Snackbar from 'utils/Snackbar';
import { addFavoriteCourse } from 'services/course.service';
import { getFeedback } from 'services/review.service';

const HeaderOption = (props: any) => {
  const { courseName, courseImage, totalSections, disableIcons } = props;

  const { user }: any = useAuth();
  // const location = useLocation();
  const navigate = useNavigate()

  const [favorite, setFavorite] = useState(props?.favorite?.includes(user?._id));
  const [averageRatings, setAverageRatings] = useState(0);

  // const { data: contentState, currentContentData: contentData } = useSelector((state: any) => state.currentContent);
  // const anchorRef = useRef<any>(null);
  // const [value, setValue] = useState(location.pathname);

  // useEffect(() => {
  //   setValue(location.pathname);
  // }, [location.pathname]);

  const getRatings = async () => {

    return getFeedback({ courseId: props?.courseId })
      .then((res: any) => {
        if (res.status === 200) {
          let response = res.data.data
          setAverageRatings(Number(Number(response.average).toFixed(1)))
          return res.data.data;
        } else {
          Snackbar(res.data.message, 'error');
        }
      })
      .catch((err: any) => {
        if (err?.response?.status === 403) {
          const errorMessage = err?.response?.data?.message || "You don't have the required permissions to perform this action.";
          Snackbar(errorMessage, 'warning');
        } else {
          const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
          Snackbar(errorMessage, 'error');
        }
      });
  };

  useEffect(() => {
    props?.courseId && getRatings()
  }, [props?.courseId])

  const handleLikeClick = () => {
    addFavoriteCourse({
      userId: user?._id,
      organizationId: user.organizationId?._id,
      courseId: props?.courseId
    })
      .then((res: any) => {
        if (res?.status === 200) {
          setFavorite(!favorite);
          Snackbar(res?.data?.message, 'success');
        } else;
      })
      .catch((err) => {
        if (err?.response?.status === 403) {
          const errorMessage = err?.response?.data?.message || "You don't have the required permissions to perform this action.";
          Snackbar(errorMessage, 'warning');
        } else {
          const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
          Snackbar(errorMessage, 'error');
        }
      });
  };


  return (
    <Card sx={{ p: { xs: 1, sm: 2 }, mb: 1, borderRadius: 3 }}>
      <Grid container alignItems="center">
        {/* Left section with back button */}
        <Grid item xs="auto">
          <ArrowLeft
            color='#222222'
            size={30}
            style={{ cursor: "pointer" }}
            onClick={() => navigate(props.navigationPath)}
          />
        </Grid>

        {/* Course image */}
        <Grid item xs="auto" sx={{ ml: { xs: 1, sm: 2 } }}>
          <Avatar
            variant="rounded"
            src={!courseImage?.path ? NoImage : `${process.env.REACT_APP_FILE_URL}${courseImage?.path}`}
            alt="course image"
            sx={{
              width: { xs: 100, sm: 150 },
              height: { xs: 60, sm: 80 },
              objectFit: 'cover',
              borderRadius: 2
            }}
          />
        </Grid>

        {/* Course info */}
        <Grid item xs sx={{ ml: { xs: 1, sm: 2 } }}>
          <Stack spacing={1}>
            <Typography
              color="#222222"
              fontWeight={600}
              fontSize={{ xs: '18px', sm: '22px' }}
              lineHeight={{ xs: '21px', sm: '25px' }}
              noWrap
            >
              {courseName}
            </Typography>

            {/* Course Stats - Now visible on all screens with responsive layout */}
            <Stack
              direction="row"
              spacing={{ xs: 1, sm: 2 }}
              flexWrap="wrap"
              alignItems="center"
            >
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Clock size={18} color="#222222" />
                <Typography
                  variant="body2"
                  color="#666666"
                  sx={{ fontSize: { xs: '12px', sm: '14px' } }}
                >
                  { props?.courseDuration }
                </Typography>
              </Stack>

              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Book1 size={18} color="#222222" />
                <Typography
                  variant="body2"
                  color="#666666"
                  sx={{ fontSize: { xs: '12px', sm: '14px' } }}
                >
                  {totalSections} Sections
                </Typography>
              </Stack>

              {
                props?.showRatings &&
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <Typography
                    variant="body2"
                    color="#222222"
                    fontWeight={600}
                    sx={{ fontSize: { xs: '12px', sm: '14px' } }}
                  >
                    {averageRatings}/5
                  </Typography>
                  <Rating
                    value={averageRatings}
                    readOnly
                    size="small"
                    precision={0.1}
                  />
                </Stack>
              }
            </Stack>
          </Stack>
        </Grid>

        {/* Action buttons */}
        <Grid item xs="auto">
          <Stack
            direction="row"
            spacing={{ xs: 0.5, sm: 1 }}
          >
            {user?.type === 'student' && <Tooltip title="Favorites">
              <IconButton
                // size={{ xs: 'small', sm: 'medium' }}
                sx={{
                  border: '0.5px solid',
                  borderColor: '#D1D1D1',
                  borderRadius: '10px'
                }}
                onClick={handleLikeClick}
              >
                <Heart
                  color={favorite ? 'red' : "black"}
                  variant={favorite ? 'Bold' : "Outline"}
                  size={20}
                />
              </IconButton>
            </Tooltip>}

            {
              props?.showDictionaryIcon &&
              <Tooltip title="Dictionary">
                <IconButton
                  // size={{ xs: 'small', sm: 'medium' }}
                  sx={{
                    border: '0.5px solid',
                    borderColor: '#D1D1D1',
                    borderRadius: '10px'
                  }}
                  disabled={disableIcons}
                  onClick={() => props.setSection({ showDictionary: true })}
                >
                  <LanguageSquare color={disableIcons ? "#E0E0E0" : "#222222"} size={20} />
                </IconButton>
              </Tooltip>
            }
            {
              props?.showBookmarkIcon &&
              <Tooltip title="Bookmarked">
                <IconButton
                  // size={{ xs: 'small', sm: 'medium' }}
                  disabled={disableIcons}
                  sx={{
                    border: '0.5px solid',
                    borderColor: '#D1D1D1',
                    borderRadius: '10px'
                  }}
                  onClick={() => props.setSection({ bookmarkOpen: true })}
                >
                  <Book color={disableIcons ? "#E0E0E0" : "#222222"} size={20} />
                </IconButton>
              </Tooltip>
            }
            {
              props?.showNoteIcon &&
              <Tooltip title="Notes">
                <IconButton
                  // size={{ xs: 'small', sm: 'medium' }}
                  disabled={disableIcons}
                  sx={{
                    border: '0.5px solid',
                    borderColor: '#D1D1D1',
                    borderRadius: '10px'
                  }}
                  onClick={() => props.setSection({ noteOpen: true })}
                >
                  <Note1 color={disableIcons ? "#E0E0E0" : "#222222"} size={20} />
                </IconButton>
              </Tooltip>
            }

            <Tooltip title="Sections">
              <IconButton
                // size={{ xs: 'small', sm: 'medium' }}
                sx={{
                  border: '0.5px solid',
                  borderColor: '#D1D1D1',
                  borderRadius: '10px'
                }}
                onClick={() => props.setSection({ sectionOpen: true })}
              >
                <SidebarLeft color="#222222" size={20} />
              </IconButton>
            </Tooltip>
          </Stack>
        </Grid>
      </Grid>
    </Card>

  );
};

export default HeaderOption;

{/* <Box 
sx={{ 
  width: '100%', 
  borderRadius: "20px", 
  padding: 2, 
  margin: 1,
  background: "#222222" 
}}> */}
{/* <style>
  {`
    .MuiTab-root {
      min-width: 40px;
    }
  `}
</style> */}
{/* <Tabs
  value={value}
  onChange={handleChange}
  onClick={props.handleClose}
  textColor="inherit"
  variant={'scrollable'}
  orientation={'horizontal'}
  // indicatorColor="#13AC9E"
  TabIndicatorProps={{
    sx: { backgroundColor: '#13AC9E', height: { lg: 4, md: 4, sm: 30 }, overflow: 'scroll' }
  }}
>
  <Grid container justifyContent={'space-between'}>
    <Grid item xs={2}>
      <Tab
        label={
          <Box>
            <Tooltip title="Go to course list">
              <ArrowLeft color="#222222"/>
            </Tooltip>
          </Box>
        }
        component={Link}
        to="/learner/mylearning"
        onClick={() => {
          props.setSection({ sectionOpen: true });
        }}
        style={{
          color: value === '/learner' ? '#13AC9E' : '#5B6B79',
          textDecoration: 'none',
          padding: '0px 8px',
          width: '40px'
        }}
      />
      <Tab
        label={
          <Box>
            <Tooltip title="Sections">
              <Category color="#000000" variant="Bulk" />
            </Tooltip>
          </Box>
        }
        onClick={() => {
          props.setSection({ sectionOpen: true });
        }}
        style={{
          color: value === '/learner' ? '#13AC9E' : '#5B6B79',
          textDecoration: 'none',
          padding: '0px 8px',
          width: '40px'
        }}
      />
    </Grid>
    <Grid item xs={8} sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center' }}>
      <Tab
        label={
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '3rem' }}>
            {props?.courseName && (
              <Typography
                sx={{
                  textTransform: 'capitalize',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'flex',
                  justifyContent: 'center',
                  WebkitLineClamp: '2',
                  WebkitBoxOrient: 'vertical',
                  color: '#000000'
                }}
                variant="h4"
              >
                {props?.courseName}
              </Typography>
            )}
            {props?.sectionName && (
              <Typography
                sx={{
                  textTransform: 'capitalize',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'flex',
                  justifyContent: 'center',
                  WebkitLineClamp: '2',
                  WebkitBoxOrient: 'vertical',
                  lineHeight: '1.5rem',
                  color: '#000000'
                }}
                variant="h5"
              >
                {props?.sectionName}
              </Typography>
            )}
          </Box>
        }
        // onClick={props.setNote}
        style={{
          textDecoration: 'none',
          padding: '0px 8px',
          width: 'auto',
          maxWidth: '100%',
          cursor: 'pointer'
        }}
      />
    </Grid>
    <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'end' }}>
      <Tab
        label={
          <Box>
            <Tooltip title="Dictionary">
              <LanguageSquare color="#000000" variant="Bulk" />
            </Tooltip>
          </Box>
        }
        onClick={() => {
          props.setSection({ showDictionary: true });
        }}
        style={{
          color: value === '/learner' ? '#13AC9E' : '#5B6B79',
          textDecoration: 'none',
          padding: '0px 8px',
          width: '40px'
        }}
      />
      <Tab
        disabled={contentData?.assessmentId}
        label={
          <Box>
            <Tooltip title="Bookmarked">
              <Bookmark color="#000000" variant="Bulk" />
            </Tooltip>
          </Box>
        }
        onClick={() => {
          props.setSection({ bookmarkOpen: true });
        }}
        style={{
          color: value === '/learner' ? '#13AC9E' : '#5B6B79',
          textDecoration: 'none',
          padding: '0px 8px',
          width: '40px'
        }}
      />
      <Tab
        disabled={contentData?.assessmentId}
        label={
          <Box>
            <Tooltip title="Add Note">
              <Add color="#000000" variant="Bulk" />
            </Tooltip>
          </Box>
        }
        onClick={() => {
          props.setSection({ addNoteOpen: true });
        }}
        style={{
          color: value === '/learner' ? '#13AC9E' : '#5B6B79',
          textDecoration: 'none',
          padding: '0px 8px',
          width: '40px'
        }}
      />

      <Tab
        disabled={contentData?.assessmentId}
        label={
          <Box>
            <Tooltip title="Notes">
              <Note1 color="#000000" variant="Bulk" />
            </Tooltip>
          </Box>
        }
        onClick={() => {
          props.setSection({ noteOpen: true });
        }}
        style={{
          color: value === '/learner' ? '#13AC9E' : '#5B6B79',
          textDecoration: 'none',
          padding: '0px 8px',
          width: '40px'
        }}
      />
    </Grid>
  </Grid>
</Tabs> */}
// </Box>